import { FC, PropsWithChildren } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { Col, Tabs } from "antd";
import Typography from "components/common/Typography";
import Header from "components/layout/Header";

import { useSettingsTabs } from "./hooks";

const Settings: FC<PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const items = useSettingsTabs({ children });

  return (
    <>
      <Header>
        <Col>
          <Typography.Title>
            <FormattedMessage defaultMessage="Settings" />
          </Typography.Title>
        </Col>
      </Header>
      <Tabs activeKey={pathname} onChange={navigate} {...{ items }} />
    </>
  );
};

export default Settings;
